import { render, staticRenderFns } from "./AppointmentBranchEditCont.vue?vue&type=template&id=66c84f3e&"
import script from "./AppointmentBranchEditCont.vue?vue&type=script&lang=js&"
export * from "./AppointmentBranchEditCont.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentBranchEditCont.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports